module.exports = __webpack_public_path__ + "static/media/product-5.8f9a1f89.png";